// extracted by mini-css-extract-plugin
module.exports = {"extrasContainer":"speedTest_extrasContainer__QLpSz","fadein":"speedTest_fadein___q5tU","loading":"speedTest_loading__4Voxz"};